import { createStore } from 'vuex'
import login from './modules/login'
import myPatients from './modules/my-patients'
import calendar from './modules/calendar'
import workbench from './modules/workbench'
import currency from './modules/currency'
import orderTest from './modules/va-order-test'
import myPractice from './modules/myPractice'
import encounterNotePatient from './modules/encounter-note-patient'
import notifications from './modules/notifications'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    login,
    myPatients,
    calendar,
    workbench,
    currency,
    orderTest,
    myPractice,
    encounterNotePatient,
    notifications,
  },
});